import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { ReactComponent as VehicleIcon } from 'assets/icons/vehicle.svg';
import eiqSecureStore from '../../stores/eiq-secure.store';
import { IPetRead } from 'common/services/residents-service/residents.service.types';
import EIQPreviewImage from 'common/components/image/eiq-preview-image';
import { UploadFileTypes } from 'common/services/file-service/file.service.types';
import './eiq-secure-pets-info.scss';

export const EiqSecurePetsInfo = observer(() => {
  const pets = useMemo(() => {
    return eiqSecureStore.residentDetails?.addresses.find((addressItem) => addressItem?.address?.id === eiqSecureStore.selectedAddressId)
      ?.pets;
  }, [eiqSecureStore.selectedAddressId, eiqSecureStore.residentDetails]);

  const getPetInfo = (pet: IPetRead) => {
    let result = pet.name;

    const getTypeColor = (type: string | null, color: string | null) => {
      if (type && color) {
        return ` - (${type}, ${color})`;
      }
      if (type) {
        return ` - (${type})`;
      }
      if (color) {
        return ` - (${color})`;
      }

      return '';
    };

    result += getTypeColor(pet.type, pet.color);

    if (pet.tag) {
      result += ` - ${pet.tag}`;
    }

    return result;
  };

  return (
    <div className="eiq-secure__vehicles-list">
      {pets?.length! > 0 && <div className="eiq-secure__title eiq-secure-subtitle">Pets info</div>}
      {pets?.map((pet) => {
        return (
          <div className="eiq-secure__vehicles-item eiq-secure__pets-item" key={pet.id}>
            {pet.photoUrl && (
              <EIQPreviewImage url={pet.photoUrl} fileType={UploadFileTypes.Image} alt="pet photo" isPublic={true} width={20} />
            )}
            {getPetInfo(pet)}
          </div>
        );
      })}
    </div>
  );
});
